import { Button, Dropdown } from "@nextui-org/react";
import React from "react";

class BranchDropDown extends React.Component{
    token = null
    full_name = null
    branchItems = null
    selectedValue = ""
    selectedDidChanged = null
    constructor(props) {
        super(props);
        this.token = props.items.token
        this.full_name = props.items.full_name
        this.selectedValue = props.items.default_branch
        this.selectedDidChanged = props.selectedDidChanged
    }

    loadBranchClick = () => {
        fetch('http://162.243.171.183:8022/user/repos/branches', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                token: this.token,
                full_name: this.full_name
            })
        })
            .then(response => response.json())
            .then(data => {
                var resList = []
                data.forEach(element => {
                    resList.push({ key: element.name, name: element.name})
                });
                this.branchItems = resList
                this.setState({ isLoading: false });
            })
            .catch(error => {
                console.error(error);
                this.setState({ isLoading: false });
            });
    }

    getCurrentBranch = ()=>{
        return this.selectedValue
    }

    selected = []
    
    setSelected = (item) => {
        this.selectedValue = item.currentKey
        this.setState({ isLoading: false });
        this.selectedDidChanged(this.full_name,this.selectedValue)
    }

    render() {
        if (this.branchItems == null || this.branchItems.length <= 0) {
            return (<Button onPress={this.loadBranchClick}>获取</Button>);
        }
        return (
            <Dropdown>
                <Dropdown.Button flat color="secondary">
                    {this.selectedValue}
                </Dropdown.Button>
                <Dropdown.Menu
                    aria-label="Single selection actions"
                    color="secondary"
                    disallowEmptySelection
                    selectionMode="single"
                    selectedKeys={this.selected}
                    onSelectionChange={this.setSelected}
                    items={this.branchItems}
                >{(item) => (<Dropdown.Item key={item.key}>{item.name}</Dropdown.Item>)
                    }
                </Dropdown.Menu>
            </Dropdown>
        );
    }

}

export default BranchDropDown;